var map = {
	"./attack-1.png": 492,
	"./attack-2.png": 493,
	"./attack-3.png": 494,
	"./attack-5.png": 495,
	"./attack.png": 496,
	"./avatar-border.png": 497,
	"./back.png": 498,
	"./blood-15.png": 499,
	"./blood-3.png": 500,
	"./blood-5.png": 501,
	"./blood-7.png": 502,
	"./board.png": 503,
	"./bonus.png": 504,
	"./coin.png": 505,
	"./dashboard-content.png": 506,
	"./day-coin.png": 507,
	"./deadly-15.png": 508,
	"./deadly-3.png": 509,
	"./deadly-5.png": 510,
	"./deadly-7.png": 511,
	"./default.png": 512,
	"./gift.png": 513,
	"./no-rank.png": 514,
	"./nosound.png": 515,
	"./number-yellow-0.png": 516,
	"./number-yellow-1.png": 517,
	"./number-yellow-2.png": 518,
	"./number-yellow-3.png": 519,
	"./number-yellow-4.png": 520,
	"./number-yellow-5.png": 521,
	"./number-yellow-6.png": 522,
	"./number-yellow-7.png": 523,
	"./number-yellow-8.png": 524,
	"./number-yellow-9.png": 525,
	"./number-yellow-D.png": 526,
	"./ok.png": 527,
	"./pre.png": 528,
	"./protect-1.png": 529,
	"./protect-2.png": 530,
	"./protect-3.png": 531,
	"./protect-5.png": 532,
	"./rank-head.png": 533,
	"./rank.png": 534,
	"./student-code.png": 535,
	"./student-item-block.png": 536,
	"./student-item.png": 537,
	"./student-level.png": 538,
	"./student-name.png": 539,
	"./student-point.png": 540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;